import React from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";
import ValidationMsgComponent from "../ValidationMsgComponent";
import { Col, Row } from "reactstrap";

interface ControlledIpdateSelectProps {
  label: string;
  inputName: string;
  placeholder?: string;
  invalid?: boolean;
  control: any;
  rules?: object;
  errors?: object;
  isRequired?: boolean;
  hasSideLabel?: boolean;
  sideLabel?: string;
  isDisabled?: boolean;
  defaultValue?: string;
  className?: string;
  optionsList: any;
  isLoading?: boolean;
  isSearchable?: boolean;
  defaultSelectedValue?: any;
  isMulti?: boolean;
  isClear?: boolean;
  value?: any;
}

const ControlledUpdateSelect: React.FC<ControlledIpdateSelectProps> = ({
  label,
  inputName,
  optionsList,
  invalid,
  control,
  isLoading,
  isSearchable,
  rules,
  errors,
  defaultSelectedValue,
  isRequired,
  isMulti,
  isDisabled,
  placeholder,
  isClear,
}) => {
  return (
    <div className="mb-1">
      <Row>
        <Col lg="4">{label && <label htmlFor={inputName}>{label}</label>}</Col>
        <Col>
          <Controller
            name={inputName}
            control={control}
            rules={rules}
            render={({ field }) => (
              <Select
                id={inputName}
                classNamePrefix="select"
                options={optionsList}
                isClearable={isClear}
                isLoading={isLoading}
                isSearchable={isSearchable}
                isMulti={isMulti}
                isDisabled={isDisabled}
                defaultValue={defaultSelectedValue}
                placeholder={placeholder}
                {...field}
                onChange={(selected) => {
                  field.onChange(
                    isMulti
                      ? selected.map((cat: any) => cat.value).join(",")
                      : selected.value
                  );
                }}
                value={
                  isMulti
                    ? field.value
                      ? field.value.split(",").map((cat: string) => ({
                          value: cat,
                          label: cat,
                        }))
                      : []
                    : field.value
                    ? {
                        value: field.value,
                        label: field.value,
                      }
                    : null
                }
                required={isRequired}
              />
            )}
          />
          {invalid && (
            <ValidationMsgComponent
              inputName={inputName}
              invalid={invalid}
              errors={errors}
              rules={rules}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ControlledUpdateSelect;


